(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-information"]) return;
  try {
    
  (() => {
    const sectionId = '{{ section.id }}';
    const sourceId = `BeatProductMeta-${sectionId}`;

    const findProductTitle = () => {
      const selectors = [
        '[data-testid="product-title"]',
        '.product-information__title',
        '.product-title',
        '.product__title',
        'h1'
      ];

      for (const selector of selectors) {
        const elements = document.querySelectorAll(selector);
        for (const element of elements) {
          if (element && element.textContent.trim()) return element;
        }
      }
      return null;
    };

    const insertBeatMeta = () => {
      const source = document.getElementById(sourceId);
      if (!source) return;

      const meta = source.querySelector('.beat-product-meta');
      if (!meta) return;

      const titleElement = findProductTitle();
      if (!titleElement) return;

      if (document.querySelector(`.beat-product-meta[data-beat-section="${sectionId}"]`)) {
        return;
      }

      const clonedMeta = meta.cloneNode(true);
      clonedMeta.dataset.beatSection = sectionId;
      titleElement.insertAdjacentElement('afterend', clonedMeta);
    };

    const run = () => {
      insertBeatMeta();
      setTimeout(insertBeatMeta, 100);
      setTimeout(insertBeatMeta, 500);
      setTimeout(insertBeatMeta, 1200);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run, { once: true });
    } else {
      run();
    }

    window.addEventListener('load', run, { once: true });

    const observer = new MutationObserver(insertBeatMeta);
    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();
})();
